import Phaser from 'phaser';
import Bat from './Bat';
import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from '../SoundAssetKeys';

export default class Bats extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.idleBats = null;
    this.batPool = null;
    this.activeBats = null;

    this.spawnWaiter = 0;

    this.idlePos = [{ x: 820,y: 280, scale: 0.3, rotation: 0 },{ x: 785,y: 240, scale: 0.2, rotation: 15 },{ x: 720,y: 280, scale: 0.25, rotation: -10 }];

    this.idleBats = [];
    let b = null;
    for (let i = 0; i < this.idlePos.length; i++) {
      b = new Bat(this.scene).setScale(0);
      b.angle = this.idlePos[i].rotation;
      b.x = 740;
      b.y = 230;
      this.add(b);
      this.idleBats.push(b);
    }

    this.spawnWaiter = Phaser.Math.Between(4,8);

    // create a pool for 10 bats
    this.batPool = [];
    for (let i = 0; i < 10; i++) {
      this.batPool.push(new Bat(this.scene));
    }
  }

  bringIdleBats () {
    let b = null;
    for (let i = 0; i < this.idlePos.length; i++) {
      b = this.idleBats[i];
      b.setScale(0);
      b.x = this.idlePos[i].x;
      b.y = this.idlePos[i].y;
      this.scene.tweens.killTweensOf(b);
      ABCyaPhaser.Tweens.addTween(b, 300, { scale: this.idlePos[i].scale }, Phaser.Math.Easing.Linear);
    }
  }

  hideIdleBats () {
    let b = null;
    for (let i = 0; i < this.idlePos.length; i++) {
      b = this.idleBats[i];
      this.scene.tweens.killTweensOf(b);
      ABCyaPhaser.Tweens.addTween(b, 300, { scale: 0 }, Phaser.Math.Easing.Linear);
    }
  }

  spawnBat () {
    const bat = this.batPool.pop();
    if (!bat) return;
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._bat, this.scene);
    bat.setScale(0);
    bat.x = 2000;
    bat.y = 264;

    const t = null;
    const o = Phaser.Math.Between(1,3);
    this.scene.tweens.killTweensOf(bat);
    if (o === 1) {
      bat.x = 785;
      bat.y = 316;

      this._createAnimationTimeline(bat, [
        { scale: 0.05, x: 785.1, y: 316.9 },
        { scaleX: 0.18,scaleY: 0.18,x: 769.3,y: 263.4 },
        { scaleX: 0.31,scaleY: 0.31,x: 745.2,y: 213.1 },
        { scaleX: 0.44,scaleY: 0.44,x: 712.4,y: 167.9 },
        { scaleX: 0.47,scaleY: 0.47,x: 671.7,y: 129.9 },
        { scaleX: 0.5,scaleY: 0.5,x: 624.7,y: 99.8 },
        { scaleX: 0.53,scaleY: 0.53,x: 573.6,y: 77.4 },
        { scaleX: 0.56,scaleY: 0.56,x: 520,y: 61.7 },
        { scaleX: 0.59,scaleY: 0.59,x: 465.1,y: 51.7 },
        { scaleX: 0.62,scaleY: 0.62,x: 409.5,y: 46.2 },
        { scaleX: 0.65,scaleY: 0.65,x: 353.7,y: 44.5 },
        { scaleX: 0.68,scaleY: 0.68,x: 297.8,y: 45.7 },
        { scaleX: 0.71,scaleY: 0.71,x: 242.2,y: 49.5 },
        { scaleX: 0.74,scaleY: 0.74,x: 186.6,y: 55.4 },
        { scaleX: 0.77,scaleY: 0.77,x: 131.2,y: 63.1 },
        { scaleX: 0.8,scaleY: 0.8,x: 76.2,y: 72.4 },
        { scaleX: 0.83,scaleY: 0.83,x: 21.4,y: 83 },
        { scaleX: 0.86,scaleY: 0.86,x: -33.1,y: 94.8 },
        { scaleX: 0.89,scaleY: 0.89,x: -87.6,y: 107.7 },
        { scaleX: 0.92,scaleY: 0.92,x: -141.6,y: 121.4 },
        { scaleX: 0.95,scaleY: 0.95,x: -195.6,y: 136.1 }
      ]);
    }
    else if (o === 2) {
      bat.x = 761;
      bat.y = 241;

      this._createAnimationTimeline(bat,[
        { scaleX: 0.05,scaleY: 0.05,x: 761.9,y: 241.9 },

        { scaleX: 0.18,scaleY: 0.18,x: 731.6,y: 196.3 },

        { scaleX: 0.31,scaleY: 0.31,x: 695.5,y: 137 },

        { scaleX: 0.44,scaleY: 0.44,x: 649,y: 87.1 },

        { scaleX: 0.47,scaleY: 0.47,x: 600.1,y: 51.6 },

        { scaleX: 0.5,scaleY: 0.5,x: 553.3,y: 71.6 },

        { scaleX: 0.53,scaleY: 0.53,x: 513.9,y: 118.2 },

        { scaleX: 0.56,scaleY: 0.56,x: 473.6,y: 166.2 },

        { scaleX: 0.59,scaleY: 0.59,x: 418.9,y: 213.2 },

        { scaleX: 0.62,scaleY: 0.62,x: 370.7,y: 222.5 },

        { scaleX: 0.65,scaleY: 0.65,x: 320,y: 179.9 },

        { scaleX: 0.68,scaleY: 0.68,x: 274,y: 138.4 },

        { scaleX: 0.71,scaleY: 0.71,x: 223.3,y: 102 },

        { scaleX: 0.74,scaleY: 0.74,x: 164.5,y: 84.1 },

        { scaleX: 0.77,scaleY: 0.77,x: 113.8,y: 98.6 },

        { scaleX: 0.8,scaleY: 0.8,x: 49.8,y: 120.4 },

        { scaleX: 0.83,scaleY: 0.83,x: -9.6,y: 140.2 },

        { scaleX: 0.86,scaleY: 0.86,x: -68.5,y: 159.7 },

        { scaleX: 0.89,scaleY: 0.89,x: -131.1,y: 181.5 },

        { scaleX: 0.92,scaleY: 0.92,x: -197.7,y: 213.2 },

        { scaleX: 0.95,scaleY: 0.95,x: -231.8,y: 241.9 },
      ]);
    }
    else {
      bat.x = 886;
      bat.y = 264;
      this._createAnimationTimeline(bat, [
        { scaleX: 0.05,scaleY: 0.05,x: 886,y: 264.5 },

        { scaleX: 0.18,scaleY: 0.18,x: 861.6,y: 210.9 },

        { scaleX: 0.31,scaleY: 0.31,x: 803.9,y: 169.7 },

        { scaleX: 0.42,scaleY: 0.42,x: 748.9,y: 135.2 },

        { scaleX: 0.48,scaleY: 0.48,x: 695.8,y: 114 },

        { scaleX: 0.51,scaleY: 0.51,x: 626.1,y: 101.3 },

        { scaleX: 0.54,scaleY: 0.54,x: 576.4,y: 99 },

        { scaleX: 0.58,scaleY: 0.58,x: 506.4,y: 105.5 },

        { scaleX: 0.61,scaleY: 0.61,x: 450.7,y: 115.2 },

        { scaleX: 0.64,scaleY: 0.64,x: 393.3,y: 132.9 },

        { scaleX: 0.67,scaleY: 0.67,x: 332.1,y: 155.4 },

        { scaleX: 0.71,scaleY: 0.71,x: 285.7,y: 177.3 },

        { scaleX: 0.74,scaleY: 0.74,x: 226.4,y: 210.8 },

        { scaleX: 0.77,scaleY: 0.77,x: 175.5,y: 243.3 },

        { scaleX: 0.8,scaleY: 0.8,x: 128.9,y: 265 },

        { scaleX: 0.84,scaleY: 0.84,x: 65.4,y: 286.4 },

        { scaleX: 0.87,scaleY: 0.87,x: 10.5,y: 300.5 },

        { scaleX: 0.9,scaleY: 0.9,x: -39.8,y: 311.5 },

        { scaleX: 0.93,scaleY: 0.93,x: -91.9,y: 317.9 },

        { scaleX: 0.97,scaleY: 0.97,x: -187.8,y: 325.4 },

        { scaleX: 1,scaleY: 1,x: -221.8,y: 303 }
      ]);
    }

    this.add(bat);
  }

  /**
   * 
   * @param {*[]} params 
   */
  _createAnimationTimeline(obj, params) {
    const wait = 64;
    const duration = 20;

    /** @type {Phaser.Tweens.Tween} */
    let lastTween = null;
    params.forEach((param, index) => {
      lastTween = ABCyaPhaser.Tweens.addTween(obj, duration, { delay: (index * wait) + (index * duration) + 64, completeDelay: wait, ...param }, Phaser.Math.Easing.Linear);
    });
    lastTween.once(Phaser.Tweens.Events.TWEEN_COMPLETE, () => this.returnBat(obj));
  }

  returnBat (b) {
    this.batPool.push(b);
  }

  tick (dt) {
    if (this.spawnWaiter <= 0) {
      this.spawnBat();
      if (Phaser.Math.Between(1,100) > 45) {
        this.spawnBat();
      }
      this.spawnWaiter = Phaser.Math.Between(100,200) / 10;
    }
    else {
      this.spawnWaiter -= dt;
    }
  }
}